export function slugify(word: string, replacement: string = "-"): string {
  return word
    .normalize("NFD") // Normalize Unicode characters (NFD form)
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics (combining characters)
    .replace(/[^\w\s-]/g, "") // Remove non-word characters except whitespace and hyphen
    .trim() // Trim leading and trailing whitespace
    .replace(/\s+/g, replacement) // Replace whitespace characters with the specified replacement
    .toLowerCase(); // Convert the string to lowercase
}

export function truncateString(input: string, maxLength: number): string {
  if (input.length <= maxLength) {
    return input; // No truncation needed if input is already within or at maxLength
  }

  // Find the last space within the maxLength limit
  let lastSpaceIndex = input.lastIndexOf(' ', maxLength);

  if (lastSpaceIndex === -1) {
    // If no space is found within the maxLength, simply truncate at maxLength
    return input.slice(0, maxLength);
  } else {
    // Otherwise, truncate at the last space before the maxLength
    return input.slice(0, lastSpaceIndex);
  }
}
